/* globals jQuery */
//https://swiperjs.com/
import Swiper from 'swiper';
import { Navigation, Pagination, Keyboard, A11y } from 'swiper/modules'; // import Swiper bundle with all modules installed

(($) => {

    const cardSwipers = document.querySelectorAll('.js-card-swiper');
    
    cardSwipers.forEach((slider, index) => {

        let swiper = slider.querySelector('.swiper');
        let swiperPagination = slider.querySelector('.swiper-pagination');
        let swiperPrev = slider.querySelector('.swiper-button-prev');
        let swiperNext = slider.querySelector('.swiper-button-next');

        const cardSwiper = new Swiper(swiper, {
            modules: [Navigation, Pagination, Keyboard, A11y],
            slidesPerView: 1,
            spaceBetween: 20,
            speed: 1000,
            loop: false,
            keyboard: {
                enabled: true
            },
            pagination: {
                el: swiperPagination,
                type: "progressbar"
            },
            navigation: {
                prevEl: swiperPrev,
                nextEl: swiperNext
            },
            a11y: {
                enabled: true,
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 40,
                },
                1000: {
                    slidesPerView: 2,
                    spaceBetween: 60,
                },
                // when window width is >= 1200px
                1200: {
                    slidesPerView: 2,
                    spaceBetween: 100,
                }
            }
        });
    });

    const gallerySwipers = document.querySelectorAll('.js-gallery-swiper');

    gallerySwipers.forEach((slider, index) => {

        let swiper = slider.querySelector('.swiper');
        let swiperPagination = slider.querySelector('.swiper-pagination');
        let swiperPrev = slider.querySelector('.swiper-button-prev');
        let swiperNext = slider.querySelector('.swiper-button-next');

        const gallerySwiper = new Swiper(swiper, {
            modules: [Navigation, Pagination, Keyboard, A11y],
            slidesPerView: 1,
            spaceBetween: 20,
            speed: 1000,
            loop: false,
            pagination: {
                el: swiperPagination,
                type: "progressbar"
            },
            navigation: {
                prevEl: swiperPrev,
                nextEl: swiperNext
            },
            keyboard: {
                enabled: true
            },
            a11y: {
                enabled: true,
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
            },
            breakpoints: {
                768: {
                    slidesPerView: 1,
                    spaceBetween: 40,
                },
                1000: {
                    slidesPerView: 1,
                    spaceBetween: 50,
                },
                // when window width is >= 1200px
                1200: {
                    slidesPerView: 1,
                    spaceBetween: 80,
                }
            }
        });
    });

})(jQuery)